import React, { useState } from 'react';
import { 
  Users, Database, Mail, MessageSquare, Layout, 
  BarChart, ShoppingCart, Book, Shield, Smartphone,
  Settings, Link, Bot, Zap
} from 'lucide-react';
import CRMFeature from '../components/crm/CRMFeature';
import CRMHero from '../components/crm/CRMHero';
import CRMPricing from '../components/crm/CRMPricing';
import SolutionsDialog from '../components/solutions/SolutionsDialog';

const features = [
  {
    title: 'CRM & Pipeline Management',
    description: 'Organize and track leads through customizable pipelines with automated follow-ups.',
    icon: Users,
    features: [
      'Lead Management & Scoring',
      'Automated Follow-Ups',
      'Pipeline Visualization',
      'Custom Fields'
    ]
  },
  {
    title: 'Marketing Automation',
    description: 'Create and automate personalized marketing campaigns across multiple channels.',
    icon: Mail,
    features: [
      'Email Campaigns',
      'SMS Marketing',
      'Workflow Automation',
      'Drip Campaigns'
    ]
  },
  {
    title: 'AI Analytics',
    description: 'Get actionable insights from your customer data with AI-powered analytics.',
    icon: BarChart,
    features: [
      'Customer Insights',
      'Performance Metrics',
      'Predictive Analytics',
      'Custom Reports'
    ]
  }
];

export default function PinoAiCRM() {
  const [showConsultation, setShowConsultation] = useState(false);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <CRMHero onStartTrial={() => setShowConsultation(true)} />
      
      <section className="py-24 bg-gray-50 dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl mb-4">
              Everything You Need to Grow Your Business
            </h2>
            <p className="mt-4 text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
              Powerful features designed to help you succeed
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <CRMFeature key={index} {...feature} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-24">
        <CRMPricing onStartTrial={() => setShowConsultation(true)} />
      </section>

      <SolutionsDialog 
        isOpen={showConsultation} 
        onClose={() => setShowConsultation(false)} 
      />
    </div>
  );
}